import * as React from 'react';
import { Reflection } from '@shapeable/villars-types';

export const ReflectionsContext = React.createContext<Reflection[]>([]);
export const ReflectionsProvider = ReflectionsContext.Provider;